import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button
} from '@chakra-ui/react'
import { RefObject } from 'react'

interface ClearQueueDialogProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => Promise<void>
    isLoading: boolean
    cancelRef: RefObject<HTMLButtonElement>
}

function ClearQueueDialog({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
    cancelRef
}: ClearQueueDialogProps) {
    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Clear Queue
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        Are you sure you want to clear the entire queue?
                        <br />
                        This action cannot be undone.
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button variant="outline" ref={cancelRef} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={onConfirm}
                            isLoading={isLoading}
                            ml={3}
                        >
                            Clear Queue
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default ClearQueueDialog
